<app-filter-option
  icon="/assets/icons/icon-16-tag.svg"
  [title]="'FILTER.LOCATION.TITLE' | translate"
  (apply)="onApply()"
  (back)="onBack()"
>
  <div class="pr-m pl-m">
    <mat-form-field
      id="form-field-location"
      (click)="$event.stopPropagation()"
      appearance="outline"
      style="font-size: 12px"
    >
      <div class="chip-list-wrapper">
        <mat-chip-grid #chipList class="chips">
          @for (location of selectedLocations; track location; let indx = $index) {
          <mat-chip-row (removed)="onRemoveLocation(indx)">
            {{ location.name }}
            <mat-icon matChipRemove style="color: black; opacity: 100; min-height: 18px; min-width: 18px"
              >close</mat-icon
            >
          </mat-chip-row>
          }
          <input
            matInput
            #LocationInput
            [formControl]="locationCtrl"
            [placeholder]="'FILTER.LOCATION.PLACEHOLDER' | translate"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          />
        </mat-chip-grid>
      </div>
      <mat-autocomplete
        #auto="matAutocomplete"
        [panelWidth]="350"
        (optionSelected)="onOptionChange($event.option.value)"
        class="autocompletion-location-list"
      >
        @for (location of selectableLocations | async; track location) {
        <div>
          <mat-option [value]="location">
            <div [ngClass]="typeToStyleClass[location.type]">
              <mat-icon class="no-margin">{{ typeToIcon[location.type] }}</mat-icon>
              {{ location.name }}
            </div>
          </mat-option>
        </div>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
</app-filter-option>
